import { render, staticRenderFns } from "./wbdp-user-list.vue?vue&type=template&id=6c4e6dd8"
import script from "./wbdp-user-list.vue?vue&type=script&lang=js"
export * from "./wbdp-user-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports